import React from 'react';
import KeyCode from 'utils/key-code';
import ClassNames from 'classnames';
import WindowListeners from 'mixins/js/WindowListeners';
import FocusRipple from 'components/animations/focus-ripple/FocusRipple';
import TouchRipple from 'components/animations/touch-ripple/TouchRipple';
import Paper from 'components/paper/Paper';

export default React.createClass({

    mixins: [ WindowListeners],

    propTypes: {
        id: React.PropTypes.string,
        inputType: React.PropTypes.string.isRequired,
        switchElement: React.PropTypes.element.isRequired,
        iconClassName: React.PropTypes.string.isRequired,
        name: React.PropTypes.string,
        value: React.PropTypes.string,
        label: React.PropTypes.string,
        onSwitch: React.PropTypes.func,
        required: React.PropTypes.bool,
        disabled: React.PropTypes.bool,
        defaultSwitched: React.PropTypes.bool,
        labelPosition: React.PropTypes.oneOf(['left', 'right']),
        disableFocusRipple: React.PropTypes.bool,
        disableTouchRipple: React.PropTypes.bool
    },

    windowListeners: {
        'keydown': '_handleWindowKeydown',
        'keyup': '_handleWindowKeyup'
    },

    getDefaultProps() {
        return {
            iconClassName: ''
        };
    },

    getInitialState() {
        return {
            switched: this.props.defaultSwitched ||
                (this.props.valueLink && this.props.valueLink.value),
            isKeyboardFocused: false
        }
    },

    componentDidMount() {
        let inputNode = this.refs.checkbox.getDOMNode();
        this.setState({
            switched: inputNode.checked
        });
    },

    componentWillReceiveProps(nextProps) {
        let hasCheckedLinkProp = nextProps.hasOwnProperty('checkedLink');
        let hasCheckedProp = nextProps.hasOwnProperty('checked');
        let hasToggledProp = nextProps.hasOwnProperty('toggled');
        let hasNewDefaultProp =
            (nextProps.hasOwnProperty('defaultSwitched') &&
                (nextProps.defaultSwitched != this.props.defaultSwitched));
        let newState = {};

        if (hasCheckedProp) {
            newState.switched = nextProps.checked;
        } else if (hasToggledProp) {
            newState.switched = nextProps.toggled;
        } else if (hasCheckedLinkProp) {
            newState.switched = nextProps.checkedLink.value;
        }

        if (newState) this.setState(newState);
    },

    render() {
        let {
            type,
            name,
            value,
            label,
            onSwitch,
            defaultSwitched,
            onBlur,
            onFocus,
            onMouseUp,
            onMouseDown,
            onMouseOut,
            onTouchStart,
            onTouchEnd,
            disableTouchRipple,
            disableFocusRipple,
            iconClassName,
            className
        } = this.props;

        let classes = ClassNames('lui-enhanced-switch', className, {
            'lui-is-switched': this.state.switched,
            'lui-is-disabled': this.props.disabled,
            'lui-is-success': this.props.status === 'success',
            'lui-is-required': this.props.required
        });

        let labelElement = this.props.label ? (
            <label className="lui-switch-label"> {this.props.label} </label>
            ) : null;

        let inputProps = {
            ref: "checkbox",
            type: this.props.inputType,
            name: this.props.name,
            value: this.props.value,
            defaultChecked: this.props.defaultSwitched,
            onBlur: this._handleBlur,
            onFocus: this._handleFocus,
            onMouseUp: this._handleMouseUp,
            onMouseDown: this._handleMouseDown,
            onMouseOut: this._handleMouseOut,
            onTouchStart: this._handleTouchStart,
            onTouchEnd: this._handleTouchEnd
        };

        if (!this.props.hasOwnProperty('checkedLink')) {
            inputProps.onChange = this._handleChange;
        }

        let inputElement = (
            <input {...this.props} {...inputProps} className="lui-enhanced-switch-input" />
        );

        let touchRipple = (
            <TouchRipple ref="touchRipple"
                key="touchRipple"
                centerRipple={true} />
        );

        let focusRipple = (
            <FocusRipple key="focusRipple"
                show={this.state.isKeyboardFocused} />
        );

        let ripples = [
            this.props.disabled || disableTouchRipple ? null : touchRipple,
            this.props.disabled || disableFocusRipple ? null : focusRipple
        ];

        iconClassName += ' lui-enhanced-switch-wrap';

        let switchElement = (this.props.iconClassName.indexOf("toggle") == -1) ? (
            <div className={iconClassName}>
                {this.props.switchElement}
                {ripples}
            </div>
        ) : (
            <div className={iconClassName}>
                <div className="lui-toggle-track" />
                <Paper className="lui-toggle-thumb" zDepth={1}>{ripples}</Paper>
            </div>
        );

        let labelPositionExist = this.props.labelPosition;

        // Position is left if not defined or invalid.
        let elementsInOrder = (labelPositionExist &&
            (this.props.labelPosition.toUpperCase() === "RIGHT")) ? (
            <div>
                {switchElement}
                {labelElement}
            </div>
        ) : (
            <div>{labelElement} {switchElement}</div>
        );

        return (
            <div className={classes}>{inputElement} {elementsInOrder}</div>
        );
    },

    isSwitched() {
        return this.refs.checkbox.getDOMNode().checked;
    },

    // no callback here because there is no event
    setSwitched(newSwitchedValue) {
        if (!this.props.hasOwnProperty('checked') || this.props.checked == false) {
            this.setState({
                switched: newSwitchedValue
            });
            this.refs.checkbox.getDOMNode().checked = newSwitchedValue;
        } else if (process.NODE_ENV !== 'production') {
            let message = 'Cannot call set method while checked is defined as a property.';
            console.error(message);
        }
    },

    getValue() {
        return this.refs.checkbox.getDOMNode().value;
    },

    isKeyboardFocused() {
        return this.state.isKeyboardFocused;
    },

    _handleChange(e) {

        this._tabPressed = false;
        this.setState({
            isKeyboardFocused: false
        });

        let isInputChecked = this.refs.checkbox.getDOMNode().checked;

        if (!this.props.hasOwnProperty('checked')) this.setState({
            switched: isInputChecked
        });
        if (this.props.onSwitch) this.props.onSwitch(e, isInputChecked);
    },

    /**
     * Because both the ripples and the checkbox input cannot share pointer
     * events, the checkbox input takes control of pointer events and calls
     * ripple animations manually.
     */

    // Checkbox inputs only use SPACE to change their state. Using ENTER will
    // update the ui but not the input.
    _handleWindowKeydown(e) {
        if (e.keyCode == KeyCode.TAB) this._tabPressed = true;
        if (e.keyCode == KeyCode.SPACE && this.state.isKeyboardFocused) {
            this._handleChange(e);
        }
    },

    _handleWindowKeyup(e) {
        if (e.keyCode == KeyCode.SPACE && this.state.isKeyboardFocused) {
            this._handleChange(e);
        }
    },

    _handleMouseDown(e) {
        //only listen to left clicks
        if (e.button === 0) this.refs.touchRipple.start(e);
    },

    _handleMouseUp(e) {
        this.refs.touchRipple.end();
    },

    _handleMouseOut(e) {
        this.refs.touchRipple.end();
    },

    _handleTouchStart(e) {
        this.refs.touchRipple.start(e);
    },

    _handleTouchEnd(e) {
        this.refs.touchRipple.end();
    },

    _handleBlur(e) {
        this.setState({
            isKeyboardFocused: false
        });

        if (this.props.onBlur) this.props.onBlur(e);
    },

    _handleFocus(e) {
        //setTimeout is needed becuase the focus event fires first
        //Wait so that we can capture if this was a keyboard focus
        //or touch focus
        setTimeout(function() {
            if (this._tabPressed) {
                this.setState({
                    isKeyboardFocused: true
                });
            }
        }.bind(this), 150);

        if (this.props.onFocus) this.props.onFocus(e);
    }

});



/** WEBPACK FOOTER **
 ** ./src/components/forms/enhanced-switch/EnhancedSwitch.js
 **/